import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { JwtHelperService } from '@auth0/angular-jwt';
import { environment } from '../../../environments/environment';
import { AutenticacionService } from './autenticacion.service';
import { UsuarioService } from '../../core/services/usuario.service';
import * as windowsIana from 'windows-iana';

@Injectable({
  providedIn: 'root'
})
export class InfoUsuarioService {

  private readonly lastNameKey: string = "LastNameUsuario";
  private readonly emailUsuarioKey: string = "EmailUsuario";
  private readonly firstNameKey: string = "FistNameUsuario";
  private readonly rolesKey: string = "Roles";
  private readonly permisosKey: string = "Permisos";
  private readonly tokenKey: string = "Token";
  private readonly usuarioIdKey: string = "Id";
  private readonly zonaHorariaServer: string = "ZonaHorariaServer";

  constructor(private http: HttpClient, 
              private router: Router, 
              private jwtHelper: JwtHelperService, 
              private autenticacionService: AutenticacionService,
              private usuarioService: UsuarioService) { }

  GuardarDatosLogin(Token: string, Id: string, FirstName: string, LastName: string, Email: string, Roles: string[], Permisos: string[], ZonaHorariaServer: string): void
  {
    const zonaHorariaIana = windowsIana.findIana(ZonaHorariaServer);
    localStorage.setItem(this.lastNameKey, LastName);
    localStorage.setItem(this.emailUsuarioKey, Email);
    localStorage.setItem(this.firstNameKey, FirstName);
    localStorage.setItem(this.tokenKey, Token);
    localStorage.setItem(this.usuarioIdKey, Id);
    localStorage.setItem(this.zonaHorariaServer, zonaHorariaIana[0]);
    localStorage.setItem(this.rolesKey, JSON.stringify(Roles));
    localStorage.setItem(this.permisosKey, JSON.stringify(Permisos));
  }

  get LastName(): string
  {
    return localStorage.getItem(this.lastNameKey);
  }

  get Email(): string
  {
    return localStorage.getItem(this.emailUsuarioKey);
  }

  get FirstName(): string
  {
    return localStorage.getItem(this.firstNameKey);
  }

  get UsuarioId(): string
  {
    return localStorage.getItem(this.usuarioIdKey);
  }

  private get Roles(): string[]
  {
    return JSON.parse(localStorage.getItem(this.rolesKey));
  }

  get Token(): string
  {
    return localStorage.getItem(this.tokenKey);
  }

  usuarioLogueado(): boolean
  {
    const token = localStorage.getItem("Token");
    if (token && !this.jwtHelper.isTokenExpired(token))
    {
      return true;
    }

    return false;
  }
  

  RevisarSiUsuarioEstaLogueado()
  {
    return new Promise<void>((resolve, reject) =>
    {
      this.usuarioEstaLogueado()
        .then(() =>
        {
          resolve();
        })
        .catch(() =>
        {
          this.router.navigate(["/login"]);
          resolve();
        });
    });
  }

  usuarioEstaLogueado(): Promise<void>
  {
    return this.http.get<void>(environment.hostService + '/auth/RevisarSiUsuarioEstaLogueado').toPromise();
  }

  async CerrarSesion(): Promise<void>
  {
    localStorage.clear();
    this.autenticacionService.sendAutenticacionChangeNotification(false);
  }

  usuarioTieneRol(rol: string): boolean
  {
    const _rolesUsuario = this.Roles;

    if (_rolesUsuario === undefined)
    {
      return false;
    }

    for (let i = 0; i < _rolesUsuario.length; i++)
    {
      if (_rolesUsuario.find(r => r === _rolesUsuario[i]) === rol)
      {
        return true;
      }
    }

    return false;
  }

  async usuarioTienePermiso(funcion: string) : Promise<boolean>
  {
    var userId = localStorage.getItem("Id");

    let permiso = false;

    await this.usuarioService.Permiso(userId, funcion).then(_ =>
      {
        permiso = true;
        console.log("Tiene permiso");
      },
      error =>
      {
        console.log("NO tiene permiso: " + error.error);
      });
    
    return permiso;
  }
}
